import { Campaign } from '@app/shared/models/campaign';
import { createAction, props } from '@ngrx/store';

export const LoadCampaign = createAction(
  '[Advertising] Load Campaign',
  props<{ target: 'Uploader' | 'Viewer' | 'All' }>()
);

export const LoadCampaignSuccess = createAction(
  '[Advertising] Load Campaign Success',
  props<{ campaign: Campaign }>()
);
